var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1667C13.2462 14.1667 12.5 14.9129 12.5 15.8333C12.5 16.7538 13.2462 17.5 14.1667 17.5C15.0871 17.5 15.8333 16.7538 15.8333 15.8333C15.8333 14.9129 15.0871 14.1667 14.1667 14.1667ZM14.1667 14.1667H7.74495C7.36058 14.1667 7.16831 14.1667 7.01009 14.0983C6.87055 14.038 6.74945 13.9407 6.66124 13.8168C6.56124 13.6765 6.52174 13.4886 6.44121 13.1127L4.3929 3.55398C4.31237 3.17813 4.27156 2.99021 4.17155 2.84983C4.08335 2.72602 3.96271 2.62868 3.82316 2.56837C3.66495 2.5 3.47316 2.5 3.08878 2.5H2.5M5 5H15.7277C16.3292 5 16.6298 5 16.8316 5.1253C17.0085 5.23505 17.1376 5.40698 17.1941 5.6073C17.2585 5.83599 17.1759 6.12497 17.0092 6.70288L15.8553 10.7029C15.7556 11.0484 15.7058 11.2212 15.6047 11.3494C15.5154 11.4626 15.3977 11.5506 15.2642 11.605C15.113 11.6666 14.9332 11.6667 14.5736 11.6667H6.44206M6.66667 17.5C5.74619 17.5 5 16.7538 5 15.8333C5 14.9129 5.74619 14.1667 6.66667 14.1667C7.58714 14.1667 8.33333 14.9129 8.33333 15.8333C8.33333 16.7538 7.58714 17.5 6.66667 17.5Z",
    stroke: "#D1D1D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCard);
export default __webpack_public_path__ + "static/media/shoppingCard.bf25b819172d10b7beadc0b7e0e4dcf2.svg";
export { ForwardRef as ReactComponent };